module.exports = __webpack_public_path__ + "img/pDingDan.41f1a1f0.png";